import { UpdateUserOnboardingStepRequestSchema } from "@amzn/client-workbench-api-model";
import { API } from "@aws-amplify/api";

import { API_METRICS_HANDLE } from "@/apis/constants";
import { Logger } from "@/apis/Logger";
import {
  publishQueryLatencyMetrics,
  publishQueryResultMetrics,
} from "@/apis/Metrics";

import { AMPLIFY_DEFAULT_API_NAME } from "../amplifyConfig";

export const USER_ONBOARDING_STEP_METRICS_NAME = "UserOnboardingStepAPICall";

type OnboardingStep = UpdateUserOnboardingStepRequestSchema["onboardingStep"];

/**
 * Updates the onboarding step in the Candidate records table.
 *
 * NOTE: This function intentionally does not throw errors to avoid blocking
 * user progress through the onboarding flow. Failures are logged and tracked
 * via metrics for monitoring, but the user experience continues uninterrupted.
 *
 * @param step the onboarding step that was completed (e.g., PD1_LOGIN, D1_COMPLETE)
 */
export const updateOnboardingStep = (step: OnboardingStep): void => {
  const startTime = performance.now();

  const body: UpdateUserOnboardingStepRequestSchema = {
    onboardingStep: step,
  };

  void API.put(AMPLIFY_DEFAULT_API_NAME, "/user/onboardingStep", {
    body: body,
  })
    .then(() => {
      publishQueryResultMetrics({
        metricsPublisherHandler: API_METRICS_HANDLE,
        queryFunctionName: `${USER_ONBOARDING_STEP_METRICS_NAME}_${step}`,
        numFailures: 0,
        numSuccess: 1,
      });
      return;
    })
    .catch((err) => {
      void Logger.errorErrorLike(
        `${USER_ONBOARDING_STEP_METRICS_NAME}_${step} failed API call.`,
        err
      );

      publishQueryResultMetrics({
        metricsPublisherHandler: API_METRICS_HANDLE,
        queryFunctionName: `${USER_ONBOARDING_STEP_METRICS_NAME}_${step}`,
        numFailures: 1,
        numSuccess: 0,
      });
    })
    .finally(() => {
      publishQueryLatencyMetrics({
        metricsPublisherHandler: API_METRICS_HANDLE,
        queryFunctionName: `${USER_ONBOARDING_STEP_METRICS_NAME}_${step}`,
        elapsedTime: performance.now() - startTime,
      });
    });
};
